import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { RestClientService } from '../services/restclient.service';
import { LoginService } from '../services/login.service';
import { SessaoService } from '../services/sessao.service';
import { MensagemService } from '../services/mensagem.service';
import { ConfiguracaoVisual } from '../modelo/configuracaoVisual';
import { ConfiguracaoVisualService } from '../services/configuracaoVisual.service';
import { MatDialog } from '@angular/material';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';
import { MidiaEnum } from '../enumaration/midiaEnum';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Autenticado, LoginRequest } from '../modelo/autenticado';
import { ControlContainer, NgForm } from '@angular/forms';
import { BraRecaptchaComponent } from '../componentes/bra-recaptcha/bra-recaptcha.component';
import { Recaptcha } from '../modelo/captcha';
import { CriptoService } from '../services/cripto.service';
import { LoginModalInvalidoComponent } from './login-modal-invalido';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService, MensagemService, RestClientService, ConfiguracaoVisualService, CriptoService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class LoginComponent extends AbstractComponent implements OnInit {

  public tipoDoc: string;
  public cpfCnpj: string;
  public senha: string;
  public parceiro: number;
  public token: string;
  public btdis: boolean = false;
  public mensagemCpfCnpj: string;
  public keyRecaptcha: string;
  public isLoaded = false;
  private aguardandoTokenRecaptcha = false;
  private tentativasTokenRecaptcha = 0;

  @ViewChild(BraRecaptchaComponent) recaptchaElem: BraRecaptchaComponent | undefined;

  /**
   * Construtor padrão
   */
  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private sessaoService: SessaoService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private configuracaoVisualService: ConfiguracaoVisualService,
    public dialog: MatDialog,
    private criptoService: CriptoService) {
    super(sessaoService);
    sessionStorage.removeItem("TEMPO_SESSAO");
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    var url = this.route.snapshot.routeConfig ? this.route.snapshot.routeConfig.path : '';
    var id_parceiro = 1;
    if (url == 'login-ford') {
      id_parceiro = 2;
    } else if (url == 'login-jeep') {
      id_parceiro = 3;
    }
    this.selecionarParceiro(id_parceiro, false);
    this.forcarLimpezaSessao();

    // Resolucao
    var WindowsSize = function () {
      // Toggle menu abrir conforme a resolucao
      var h = $(window).height(),
        w = $(window).width();

      // Conteudo altura
      $(".login").css('height', h);
      $(".footer").css('width', w);
    };
    $(document).ready(WindowsSize);
    $(window).resize(WindowsSize);

    // Condição para exibir modal de primeiro acesso e campanha
    sessionStorage.setItem("modalPrimeiroAcessoCampanha", "true");
  }

  /**
   * Força a limpeza da sessão
   */
  forcarLimpezaSessao() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
  }

  /**
   * Método chamada no botão avançar para ir para a tela inicial
   */
  onClickAvancar = (): void => {
    this.btdis = true;
    if (this.precisaExecutarRecaptchaInvisivel() && this.recaptchaElem) {
      this.token = '';
      this.tentativasTokenRecaptcha = 0;
      this.aguardandoTokenRecaptcha = true;
      this.recaptchaElem.execute();
      return;
    }

    if (!this.validacaoBasica()) {
      this.senha = '';
      this.token = '';
      this.mensagemService.show( this.campos);
      this.btdis = false;
      if (this.recaptchaElem) this.recaptchaElem.reload();
    } else {
      this.criptografarSenha();
    }
  };

  /**
   * Acionado pelo recaptcha após a validação ou expiração
   * @param token
   */
  onTokenChanged(token: string) {
    this.token = token;

    if (!this.aguardandoTokenRecaptcha) {
      return;
    }

    if (!token) {
      if (this.recaptchaElem && this.tentativasTokenRecaptcha < 1) {
        this.tentativasTokenRecaptcha++;
        this.recaptchaElem.execute();
        return;
      }

      this.aguardandoTokenRecaptcha = false;
      this.btdis = false;
      if (this.recaptchaElem) this.recaptchaElem.reload();
      return;
    }

    this.aguardandoTokenRecaptcha = false;
    this.tentativasTokenRecaptcha = 0;
    if (this.validacaoBasica()) {
      this.criptografarSenha();
    } else {
      this.btdis = false;
    }
  }

  private precisaExecutarRecaptchaInvisivel(): boolean {
    return !!this.keyRecaptcha && !!this.recaptchaElem;
  }

  /**
   * Validação Básica da tela
   */
  validacaoBasica = (): boolean => {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;

    if (!this.tipoDoc) {
      this.campos.push("tipoDoc");
      isValid = false;
    }

    if (!this.cpfCnpj) {
      this.mensagemCpfCnpj = this.getMensagem("CPF_CNPJ_OBRIGATORIO");
      this.campos.push("cpfCnpj");
      isValid = false;
    }

    if (!this.senha) {
      this.campos.push("password");
      isValid = false;
    }

    return isValid;
  }


  /**
   * Realiza a criptografia da senha
   */
  criptografarSenha() {
    this.criptoService.criptografar(this.senha).then(data => {
      this.validarLogin(data);
    })
  }

  /**
   * Faz a validação dos dados de entrada e efetua o login
   */
  validarLogin(senhaCriptogradada: string) {
    let nuCpfCnpj = '';
    if (this.tipoDoc === '1') {
      nuCpfCnpj = this.cpfCnpj.replace(/[^\d]+/g, '');
    } else {
      nuCpfCnpj = this.cpfCnpj.replace(/[^A-Za-z0-9]/g, '');
    }

    let requestValidarLogin: LoginRequest = {
      cdMidia: MidiaEnum.INTERNET,
      nuCpfCnpj: nuCpfCnpj,
      cdTipoCpfCnpj: this.tipoDoc,
      vrSenha: senhaCriptogradada,
      token: this.token
    }

    this.loginService.validarLogin(requestValidarLogin).subscribe(
      (result: Autenticado) => {
        this.spinnerService.hide();
        if (result.cdMsgemRetorno === '0') {
          this.sessaoService.sessao.autenticado = result;
          this.sessaoService.sessao.logado = true;
          sessionStorage.setItem("sessaoBF", JSON.stringify(this.sessaoService.sessao));
          sessionStorage.setItem("TEMPO_SESSAO", result.tempoSessao ? result.tempoSessao : '');
          sessionStorage.setItem("nuDocX", btoa(nuCpfCnpj));
          this.selecionarParceiro(result.parceiro.cdParceiro, true);
        } 
        //5001 ou 5005
        else if(result.cdMsgemRetorno === '5001' || result.cdMsgemRetorno === '5005') {
          this.dialog.open(LoginModalInvalidoComponent, {
            width: Config.POPUP_50VW
          });
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno,
              codigo: result.cdMsgemRetorno,
              linkChat: result.cdMsgemRetorno === '8' || result.cdMsgemRetorno === '22'

            }
          });
          this.senha = '';
          this.token = '';
          this.aguardandoTokenRecaptcha = false;
          if (this.recaptchaElem) this.recaptchaElem.reload();
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
        this.btdis = false;
      }
    );
  };


  /**
   * Redireciona para a tela de redefinição de senha
   */
  redefinirSenha = () => {
    this.router.navigate(['/redefinirSenha', { cdPagina: 2 }]);
  }

  /**
   * Método para seleção do parceiro
   */
  selecionarParceiro = (cdParceiro: number, redirect: boolean): void => {
    this.configuracaoVisualService.recuperarConfiguracaoParceiro(cdParceiro).subscribe(
      (result: ConfiguracaoVisual) => {
        this.spinnerService.hide();
        if (result.cdMsgemRetorno === '0' || result.cdMsgemRetorno === '2') {
          this.sessaoService.sessao.configuracaoVisual = result;
          this.sessaoService.sessao.cor = "rgb(" + result.nuCorR + ", " + result.nuCorG + ", " + result.nuCorB + ")";
          sessionStorage.setItem("sessaoBF", JSON.stringify(this.sessaoService.sessao));
          if (redirect) this.router.navigate(['primeiro-acesso-token']);
          else this.obterTipoValidacao();
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Obtém o tipo de validação
   */
  obterTipoValidacao() {
    this.keyRecaptcha = this.sessaoService.sessao.keyRecaptcha;
    if (this.keyRecaptcha) {
      this.isLoaded = true;
    } else {
      this.obterRecaptcha();
    }
  }

  /**
   * Obtem o recaptcha para renderização
   */
  obterRecaptcha() {
    this.loginService.obterReCaptcha().subscribe(
      (result: Recaptcha) => {
        this.spinnerService.hide();
        if (result && result.nmRecaptcha) {
          this.isLoaded = true;
          this.sessaoService.sessao.keyRecaptcha = result.nmRecaptcha;
          this.keyRecaptcha = result.nmRecaptcha;
        } else {
          this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/login/login.component.ts